import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DetailedSearchResultsGrid from './DetailedSearchResultsGrid';

import {
  getSeletedType,
  getUsers,
  getInputText,
  retriveUsers,
  onSelect
} from './store/action';

const DetailedSearchResultContainer = (
  {
    items,
    total,
    rowCount,
    currentPage: currentpage,
    variant,
    type,
    isFetchingResult,
    searchTerm,
    retriveUsers
  },
  context
) => {
  // API To-Do
  const getDetailedSearchResults = (currentPage, sortQuery) => {
    const fetchParams = {
      offset: currentPage * rowCount,
      limit: rowCount,
      searchTerm,
      sort: sortQuery || '',
      searchType: type || null
    };
    retriveUsers({
      fetchParams: { ...fetchParams },
      currentPage
    });
  };

  const onDataRowClick = ({ rowData, props }, { editMode }) => {
    const rowObj = rowData || props.data;
    context.router.push({
      pathname: `/usermanagement/user/${rowObj.userId}`,
      state: { editMode }
    });
  };

  return (
    <DetailedSearchResultsGrid
      data={items}
      total={total}
      getExternalData={getDetailedSearchResults}
      rowCount={rowCount}
      onDataRowClick={onDataRowClick}
      currentPage={currentpage}
      dataFetching={isFetchingResult}
      variant={variant}
      type={type}
    />
  );
};

DetailedSearchResultContainer.propTypes = {
  items: PropTypes.array,
  total: PropTypes.number,
  type: PropTypes.string,
  currentPage: PropTypes.number
};

DetailedSearchResultContainer.defaultProps = {
  items: [],
  total: 0,
  type: 'Driver',
  currentPage: 0
};

DetailedSearchResultContainer.contextTypes = {
  router: PropTypes.shape({})
};

const mapStateToProps = state => {
  //   state
  // );
  const type = getSeletedType(state);

  const variant = 'iceBlue';
  const { data, paging, loading } = getUsers(state);
  const { totalRecordCount, limit, offset } = paging;
  const currentPage = offset / limit;
  return {
    type,
    variant,
    isFetchingResult: loading,
    total: totalRecordCount,
    items: data,
    currentPage,
    searchTerm: getInputText(state),
    rowCount: limit || 0
  };
};

const mapDispatchToProps = dispatch => ({
  retriveUsers: bindActionCreators(retriveUsers, dispatch),
  select: bindActionCreators(onSelect, dispatch)
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailedSearchResultContainer);



// WEBPACK FOOTER //
// ./src/features/userManagement/DetailedSearchResultContainer.js